<template>
    <Field
        :name="name"
        :value="value"
        label="BP"
        autocomplete="new-password"
        :errors="errors"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
    />
</template>

<script>
    import Field from "../Field";

    export default {
        components: {
            Field
        },
        props: {
            name: String,
            value: String,
            errors: Object,
        },
        methods: {
            handleInput(value) {
                this.$emit('input', value);
            },
            handleFocus() {
                if(!this.value) {
                    this.$emit('input', 'BP ');
                }
            },
            handleBlur() {
                if(this.value?.match(/^BP\s*$/)) {
                    this.$emit('input', '');
                }
            },
        },
    }
</script>
